module.exports = __webpack_public_path__ + "img/ameise.de52375.svg";